import { GeneralDialog } from "../../../../controls/GeneralDialog";
  
  type Props = {
    open: boolean;
    onClose: () => void;
    onSubmit: () => void;
    text?: string;
    alertText?: string;
    children?: JSX.Element | JSX.Element[];
  };
  
  const ModificationsDialog = (props: Props) => {
    const { open, onClose, onSubmit, text, alertText, children } = props;

    return <GeneralDialog
            open={open}
            onClose={()=>onClose()}
            onSave={()=>{onSubmit(); onClose()}}
            title={`Impact of Modifications`}
            text={text ? text : ' '}
            applyText='Apply'
            alertText={alertText}>
              {children}
            </GeneralDialog>
  };
  
  export default ModificationsDialog;
  